/* src/app/forms/prompt-filter-view/prompt-filter-view.component.scss */
.content {
  width: 100%;
  display: flex;
}
.content > * {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.full {
  width: 100% !important;
}
.data-content {
  width: 100%;
  border-radius: var(--tem-radius);
  padding: 20px;
}
.filter-card {
  border-radius: var(--tem-radius);
  box-shadow: var(--tem-shadow);
}
.card-header-title {
  display: flex;
  align-items: center;
  gap: var(--tem-space-2);
  color: var(--tem-ink);
}
.header-image {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: var(--tem-accent-soft);
  color: var(--tem-deep);
}
.actions-buttons {
  display: flex;
  flex-direction: row;
  width: 100%;
  gap: 10px;
  justify-content: flex-end;
  margin-top: var(--tem-space-3);
}
/*# sourceMappingURL=prompt-filter-view.component.css.map */
